import localFont from 'next/font/local';

export const MartianMonoFont = localFont({
  src: [
    { path: './martianmono-thin.ttf', weight: '100' },
    { path: './martianmono-extralight.ttf', weight: '200' },
    { path: './martianmono-light.ttf', weight: '300' },
    { path: './martianmono-regular.ttf', weight: '400' },
    { path: './martianmono-medium.ttf', weight: '500' },
    { path: './martianmono-semibold.ttf', weight: '600' },
    { path: './martianmono-bold.ttf', weight: '700' },
    { path: './martianmono-extrabold.ttf', weight: '800' },
  ],
});

export const MartianMono = MartianMonoFont.style.fontFamily;
